import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { useTheme } from 'foundations-theming/utils';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { SkeletonBlock, SkeletonWrapper } from '../Skeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContentCardSkeleton = ({
  use = 'on-light'
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const theme = useTheme();
  const skeletonColor = use === 'on-dark' ? 'do-not-use-pantera' : 'fill-accent-neutral-subtle-alt';
  return /*#__PURE__*/_jsx(CardWrapper, {
    "data-test-id": "card-skeleton",
    marginInlineEnd: isMobile ? '400' : undefined,
    children: /*#__PURE__*/_jsx(View, {
      backgroundColor: use === 'on-light' || use === 'on-surface-recessed' ? 'fill-surface-default' : use === 'on-dark' ? 'do-not-use-monolith' : 'do-not-use-great-white',
      blockSize: "326px",
      borderRadius: "100",
      children: /*#__PURE__*/_jsxs(SkeletonWrapper, {
        shimmerColor: use === 'on-dark' ? theme.color['do-not-use-pantera'] : undefined,
        children: [/*#__PURE__*/_jsx(SkeletonBlock, {
          color: skeletonColor,
          height: theme.space['250']
        }), /*#__PURE__*/_jsx(View, {
          blockSize: "120px",
          borderBlockEndColor: use === 'on-dark' ? 'do-not-use-monolith' : 'border-core-disabled',
          borderBlockEndStyle: "solid",
          borderBlockEndWidth: "100",
          children: /*#__PURE__*/_jsx(View, {
            paddingInline: "250",
            children: /*#__PURE__*/_jsxs(Flex, {
              justifyContent: "space-between",
              children: [/*#__PURE__*/_jsxs(Flex, {
                flexDirection: "column",
                inlineSize: "100%",
                children: [/*#__PURE__*/_jsx(View, {
                  marginBlockStart: "250",
                  children: /*#__PURE__*/_jsx(SkeletonBlock, {
                    color: skeletonColor,
                    height: theme.space['400'],
                    width: "40%"
                  })
                }), /*#__PURE__*/_jsx(View, {
                  marginBlockStart: "300",
                  children: /*#__PURE__*/_jsx(SkeletonBlock, {
                    color: skeletonColor,
                    height: theme.space['500'],
                    width: "90%"
                  })
                }), /*#__PURE__*/_jsx(View, {
                  marginBlockStart: "300",
                  children: /*#__PURE__*/_jsx(SkeletonBlock, {
                    color: skeletonColor,
                    height: theme.space['500'],
                    width: "75%"
                  })
                })]
              }), /*#__PURE__*/_jsx(SkeletonBlock, {
                borderBottomLeftRadius: "50px",
                borderBottomRightRadius: "50px",
                color: skeletonColor,
                height: "50px",
                width: "50px"
              })]
            })
          })
        }), /*#__PURE__*/_jsx(View, {
          blockSize: "150px",
          children: /*#__PURE__*/_jsxs(View, {
            paddingInline: "250",
            children: [/*#__PURE__*/_jsx(View, {
              marginBlockStart: "300",
              children: /*#__PURE__*/_jsx(SkeletonBlock, {
                color: skeletonColor,
                height: theme.space['500'],
                width: "25%"
              })
            }), /*#__PURE__*/_jsx(View, {
              marginBlockStart: "600",
              children: /*#__PURE__*/_jsx(SkeletonBlock, {
                color: skeletonColor,
                height: "14px",
                width: "95%"
              })
            }), /*#__PURE__*/_jsx(View, {
              marginBlockStart: "300",
              children: /*#__PURE__*/_jsx(SkeletonBlock, {
                color: skeletonColor,
                height: "14px",
                width: "98%"
              })
            }), /*#__PURE__*/_jsx(View, {
              marginBlockStart: "300",
              children: /*#__PURE__*/_jsx(SkeletonBlock, {
                color: skeletonColor,
                height: "14px",
                width: "80%"
              })
            }), /*#__PURE__*/_jsx(View, {
              marginBlockStart: "300",
              children: /*#__PURE__*/_jsx(SkeletonBlock, {
                color: skeletonColor,
                height: "14px",
                width: "82%"
              })
            })]
          })
        })]
      })
    })
  });
};
export default ContentCardSkeleton;